import { render, staticRenderFns } from "./ViewedReports.vue?vue&type=template&id=60b682a8&scoped=true"
import script from "./ViewedReports.vue?vue&type=script&lang=js"
export * from "./ViewedReports.vue?vue&type=script&lang=js"
import style0 from "./ViewedReports.vue?vue&type=style&index=0&id=60b682a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b682a8",
  null
  
)

export default component.exports